import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import BottomBar from "../../atoms/BottomBar/BottomBar";
import { getIconPath } from "../../Functions/GetIconPath";
import { setBottomBarOpen } from "../../redux/reducers/appReducer";
import { useAppDispatch, useAppSelector } from "../../redux/store";

const BottomBarComponent: React.FC = () => {
    const dispatch = useAppDispatch();
    const bottomBarOpen = useAppSelector((state) => state.app.bottomBarOpen);
    const [buttonHover, setButtonHover] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if(bottomBarOpen) setButtonHover(false);
    }, [bottomBarOpen]);

    return (
        <BottomBar bottomDrawerOpen={bottomBarOpen}>
            <BottomBar.opener bottomDrawerOpen={bottomBarOpen}>
                {/* <button onClick={() => dispatch(setBottomBarOpen(!bottomBarOpen))}>
                    <img style={{ transform: bottomBarOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} src={getIconPath('arrowUp')} alt="Arrow" />
                </button> */}
                <p style={{ display: buttonHover ? 'block' : 'none' }}>{t('electrical_cabinet.opener')}</p>
                <div onMouseEnter={() => setButtonHover(true)} onMouseLeave={() => setButtonHover(false)} onClick={() => dispatch(setBottomBarOpen(!bottomBarOpen))}>
                   <img src={buttonHover ? getIconPath('electrical_cabinet') : getIconPath('electrical_cabinet_active')}/>
                </div>
            </BottomBar.opener>
            {bottomBarOpen && (
                <>
                    <BottomBar.dinRail/>
                    <BottomBar.actuators/>
                </>
            )}
        </BottomBar>
    );
}

export default BottomBarComponent;